import { render, staticRenderFns } from "./UiTextEdit.vue?vue&type=template&id=02f5bd9f&scoped=true&"
import script from "./UiTextEdit.vue?vue&type=script&lang=js&"
export * from "./UiTextEdit.vue?vue&type=script&lang=js&"
import style0 from "./UiTextEdit.vue?vue&type=style&index=0&id=02f5bd9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f5bd9f",
  null
  
)

export default component.exports